import * as c from 'common/c'

export const hardwareFetched = (data) => {
  return {
    type: c.HARDWARE_FETCHED,
    payload: data,
  }
}
